/* eslint-disable camelcase */
// @ts-check

/**
 * @param {number} tcfPolicyVersion
 * @returns {boolean}
 */
export const isTCFVersion2_2 = (tcfPolicyVersion) => tcfPolicyVersion === 4

export const TCFVersion2_2_SupportedPurposeLI = [2, 7, 8, 9, 10, 11]
